module.exports = __webpack_public_path__ + "static/dojazd-photo04-b4dba99b9d16a1f98a5ddc73c53f71b1.jpg";